export const accessMapping = {
    "Full Access": "Full Access",
    "Read Only + Exchange": "Read Only + Exchange",
    "Read Only": "Read Only Access",
    "No Access": "Paper Access"
}

export default accessMapping;